import React from 'react';
import PropTypes from 'prop-types';
import { Button, Typography } from '@mui/material';
import { removeFromCart } from '../../../../redux/actions/cartactions';
import { formatPrice } from '../../../../utils/utils';

const CartItem = ({name, description, price, itemIndex}) => {
    const handleRemoveItem = () => {
        removeFromCart(itemIndex);
    };

    return (
        <div className='cart-item-container'>
            <div className="cart-item-content space-between">
                <div className="cart-item-data">
                    <Typography variant="h6">{name}</Typography>
                    <Typography>{description}</Typography>
                </div>
                <div className="cart-item-price">
                    <Typography variant="h6">{formatPrice(price)}</Typography>
                </div>
            </div>
            <div className="cart-item-action">
                <Button onClick={handleRemoveItem}>Remove</Button>
            </div>
        </div>
    );
};

export default CartItem;
CartItem.propTypes = {
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    itemIndex: PropTypes.number.isRequired,
};